import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdbd4b2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between pb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_3 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_10 = {
  key: 2,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Физ. лицо не прошел проверку службы безопасности", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  aclass: "text-sm text-gray-400"
}
const _hoisted_15 = { class: "flex justify-end items-center mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_courier_schedule = _resolveComponent("courier-schedule")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CourierForm",
    onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitManager && _ctx.emitManager(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, {
        title: _ctx.isCreate ? 'Добавление курьера' : 'Редактирование курьера'
      }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_input, {
        placeholder: "ИИН",
        value: _ctx.state.iin,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.iin) = $event)),
        "is-invalid": _ctx.state_form$.iin.$error,
        "validation-errors": _ctx.state_form$.iin.$errors,
        disabled: _ctx.isIINDisabled,
        onInput: _ctx.resetSbState
      }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "onInput"]),
      (_ctx.isNotFound && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.sb_state.is_already_created)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Курьер с таким ИИН уже существует"))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, "Курьер с таким ИИН не найден!"))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRejected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", null, [
              _hoisted_8,
              _createTextVNode(" (" + _toDisplayString(_ctx.sb_state.reject_comment) + ") ", 1)
            ]),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (_ctx.isNotChecked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
        : _createCommentVNode("", true),
      (_ctx.step === 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createVNode(_component_the_select, {
              value: _ctx.state.dispatchers_sector_id,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dispatchers_sector_id) = $event)),
              placeholder: "Сектор диспетчера",
              "is-invalid": _ctx.state_form$.dispatchers_sector_id.$error,
              "validation-errors": _ctx.state_form$.dispatchers_sector_id.$errors,
              loading: _ctx.data_state.dispatchers_sectors.is_loading,
              options: _ctx.data_state.dispatchers_sectors.list,
              failed: _ctx.data_state.dispatchers_sectors.is_failed,
              "error-text": "При получении списка секторов диспетчера произошла ошибка",
              "search-by": "name",
              "select-by": "id",
              label: "name",
              onRefresh: _ctx.loadDispatchersSectors
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
            _createVNode(_component_the_select, {
              class: "mt-2",
              value: _ctx.state.typeIds,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.typeIds) = $event)),
              placeholder: "Тип курьера",
              "is-invalid": _ctx.state_form$.typeIds.$error,
              "validation-errors": _ctx.state_form$.typeIds.$errors,
              loading: _ctx.data_state.types.is_loading,
              options: _ctx.data_state.types.list,
              failed: _ctx.data_state.types.is_failed,
              searchable: false,
              multiselect: "",
              "error-text": "При получении списка типов курьера произошла ошибка",
              "select-by": "id",
              label: "title",
              onRefresh: _ctx.loadCourierTypes
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
            _createVNode(_component_the_select, {
              class: "mt-2",
              value: _ctx.state.company_id,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.company_id) = $event)),
              placeholder: "Компания",
              "is-invalid": _ctx.state_form$.company_id.$error,
              "validation-errors": _ctx.state_form$.company_id.$errors,
              loading: _ctx.data_state.companies.is_loading,
              options: _ctx.data_state.companies.list,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка компаний произошла ошибка",
              "search-by": "name",
              "select-by": "id",
              label: "name",
              "infinite-scroll": "",
              onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.companies.pagination.current_page))),
              onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.companies.pagination.current_page + 1))),
              onSearch: _ctx.searchCarriers,
              onOptionBySearch: _ctx.unshiftFindedCarrier
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
            _createVNode(_component_the_input, {
              placeholder: "ФИО",
              value: _ctx.state.full_name,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.full_name) = $event)),
              "is-invalid": _ctx.state_form$.full_name.$error,
              "validation-errors": _ctx.state_form$.full_name.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Логин (телефон)",
              value: _ctx.state.phone_number,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.phone_number) = $event)),
              "is-invalid": _ctx.state_form$.phone_number.$error,
              "validation-errors": _ctx.state_form$.phone_number.$errors,
              maska: _ctx.PHONE_NUMBER_MASK
            }, null, 8, ["value", "is-invalid", "validation-errors", "maska"]),
            (!_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 0,
                  placeholder: "Пароль",
                  value: _ctx.state.password,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.password) = $event)),
                  "is-invalid": _ctx.state_form$.password.$error,
                  "validation-errors": _ctx.state_form$.password.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_select, {
              class: _normalizeClass({
                        'mt-3': !_ctx.isUpdate,
                        'mt-1': _ctx.isUpdate,
                    }),
              value: _ctx.state.payment_rate,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.payment_rate) = $event)),
              placeholder: "Выберите тип оплаты",
              "is-invalid": _ctx.state_form$.payment_rate.$error,
              "validation-errors": _ctx.state_form$.payment_rate.$errors,
              loading: false,
              options: _ctx.CourierPaymentTypes,
              searchable: false,
              label: "name"
            }, null, 8, ["class", "value", "is-invalid", "validation-errors", "options"]),
            _createVNode(_component_the_input, {
              placeholder: "Сумма оплаты",
              value: _ctx.state.payment_amount,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.payment_amount) = $event)),
              "is-invalid": _ctx.state_form$.payment_amount.$error,
              "validation-errors": _ctx.state_form$.payment_amount.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_select, {
              class: "mt-2",
              value: _ctx.state.car_id,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.car_id) = $event)),
              placeholder: "Машина",
              "is-invalid": _ctx.state_form$.car_id.$error,
              "validation-errors": _ctx.state_form$.car_id.$errors,
              loading: _ctx.data_state.cars.is_loading,
              options: _ctx.data_state.cars.list,
              failed: _ctx.data_state.cars.is_failed,
              "error-text": "При получении списка машин произошла ошибка",
              "search-by": "number",
              "select-by": "id",
              "infinite-scroll": "",
              onRefresh: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadCars(_ctx.data_state.cars.pagination.current_page))),
              onLoadmore: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadMoreCars(_ctx.data_state.cars.pagination.current_page + 1))),
              onSearch: _ctx.searchCars,
              onOptionBySearch: _ctx.unshiftFindedCars
            }, {
              "selected-option": _withCtx(({ option }) => [
                (option.company)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number) + " (" + _toDisplayString(option.company.name) + ") ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                    ], 64))
              ]),
              option: _withCtx(({ option }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1),
                  (option.company)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(option.company.name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
            (!_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_file_reader, {
                  key: 1,
                  class: "mt-2",
                  accept: "image/*",
                  placeholder: "Удостоверение",
                  multiple: "",
                  disabled: _ctx.loading,
                  value: _ctx.state.certificate,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.certificate) = $event))
                }, null, 8, ["disabled", "value"]))
              : _createCommentVNode("", true),
            (!_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_file_reader, {
                  key: 2,
                  class: "mt-2",
                  accept: "image/*",
                  placeholder: "Водительские права",
                  multiple: "",
                  disabled: _ctx.loading,
                  value: _ctx.state.driver_license,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.driver_license) = $event))
                }, null, 8, ["disabled", "value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_input, {
              placeholder: "Номер удостоверения личности",
              "is-invalid": _ctx.state_form$.courierLicenses.identifyCardNumber.$error,
              "validation-errors": _ctx.state_form$.courierLicenses.identifyCardNumber.$errors,
              value: _ctx.state.courierLicenses.identifyCardNumber,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.courierLicenses.identifyCardNumber) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата выдачи удостоверения личности",
              "is-invalid": _ctx.state_form$.courierLicenses.identifyCardIssueDate.$error,
              "validation-errors": _ctx.state_form$.courierLicenses.identifyCardIssueDate.$errors,
              value: _ctx.state.courierLicenses.identifyCardIssueDate,
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.courierLicenses.identifyCardIssueDate) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              placeholder: "Номер водительского удостоверения",
              "is-invalid": _ctx.state_form$.courierLicenses.driverLicenseNumber.$error,
              "validation-errors": _ctx.state_form$.courierLicenses.driverLicenseNumber.$errors,
              value: _ctx.state.courierLicenses.driverLicenseNumber,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.courierLicenses.driverLicenseNumber) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата выдачи водительского удостоверения",
              "is-invalid": _ctx.state_form$.courierLicenses.driverLicenseIssueDate.$error,
              "validation-errors": _ctx.state_form$.courierLicenses.driverLicenseIssueDate.$errors,
              value: _ctx.state.courierLicenses.driverLicenseIssueDate,
              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.courierLicenses.driverLicenseIssueDate) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              value: _ctx.state.code_1c,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.code_1c) = $event)),
              placeholder: "Код 1С"
            }, null, 8, ["value"]),
            (_ctx.isCreate)
              ? (_openBlock(), _createBlock(_component_courier_schedule, {
                  key: 3,
                  schedules: _ctx.state.schedules,
                  onAdd: _ctx.onScheduleAdd,
                  onRemove: _ctx.onScheduleRemove
                }, null, 8, ["schedules", "onAdd", "onRemove"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.step === 1)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "submit-btn small primary",
            type: "submit",
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Проверить ")
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (_ctx.step === 2)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            class: "small primary",
            type: "submit",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.isCreate ? 'Создать' : 'Редактировать'), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}